{
  "title": "Serah Terima Pasien (I-PASS)",
  "illnessSeverity": "Tingkat Keparahan Penyakit",
  "patientSummary": "Ringkasan Pasien",
  "actionList": "Daftar Tindakan",
  "situationAwareness": "Kesadaran Situasi",
  "synthesis": "Sintesis oleh Penerima",
  "acknowledge": "Konfirmasi Serah Terima",
  "severity": {
    "stable": "Stabil",
    "watcher": "Dipantau",
    "unstable": "Tidak Stabil"
  },
  "loading": "Loading handoffs…",
  "errorState": "Could not load handoffs.",
  "emptyState": "No handoffs waiting for you.",
  "unknownPatient": "Unknown patient",
  "from": "Handed over by {{name}}",
  "openChart": "Open chart",
  "notProvided": "Not provided",
  "noActions": "No actions listed.",
  "noContingency": "No contingency plan was given. Ask the outgoing clinician what to watch for.",
  "synthesisHint": "Read back what you understood. This is the step the protocol exists to force.",
  "synthesisPlaceholder": "In my own words, the plan is…",
  "acknowledgedAt": "Acknowledged {{when}}",
  "toast": {
    "acknowledged": "Handoff acknowledged",
    "acknowledgeFailed": "Could not acknowledge the handoff"
  },
  "ipass": {
    "illness": "I — Illness severity",
    "patientSummary": "P — Patient summary",
    "actionList": "A — Action list",
    "situationAwareness": "S — Situation awareness",
    "contingencyPlan": "S — Contingency plan",
    "synthesis": "S — Synthesis by receiver"
  }
}
